import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Rss, Clipboard, Plus, User } from 'lucide-react';

const PhoneHeader = memo(({ onProfileClick }) => {
  return (
    <div
      className="h-[56px] min-h-[56px] flex items-center justify-between px-5 bg-[#F8F5EE]"
      style={{ borderBottom: '1px solid rgba(0,0,0,0.07)' }}
    >
      <div className="w-8" />
      <h1
        className="font-brand text-[38px] leading-none text-[#064e3b]"
        style={{ letterSpacing: '-0.5px' }}
      >
        escarole
      </h1>
      <button
        onClick={onProfileClick}
        className="w-8 h-8 flex items-center justify-center"
        aria-label="Profile"
      >
        <User className="w-[18px] h-[18px]" style={{ color: 'rgba(0,0,0,0.35)' }} strokeWidth={1.5} />
      </button>
    </div>
  );
});

PhoneHeader.displayName = 'PhoneHeader';

PhoneHeader.propTypes = {
  onProfileClick: PropTypes.func,
};

export const BottomTabBar = memo(({ activeTab, setActiveTab, onAddClick }) => {
  const feedActive = activeTab === 'feed';
  const clipsActive = activeTab === 'clipboard';

  return (
    <div
      className="flex items-center justify-around px-6 bg-[#F8F5EE]"
      style={{ height: '60px', borderTop: '1px solid rgba(0,0,0,0.07)' }}
    >
      {/* Feed */}
      <button
        onClick={() => setActiveTab('feed')}
        className="flex flex-col items-center justify-center gap-[3px] px-4 py-2 rounded-full transition-all"
        style={{ background: feedActive ? 'rgba(0,0,0,0.07)' : 'transparent' }}
        aria-label="Feed"
      >
        <Rss
          className="w-[18px] h-[18px]"
          style={{ color: feedActive ? '#064e3b' : 'rgba(0,0,0,0.35)' }}
          strokeWidth={1.75}
        />
        <span
          className="text-[10px] leading-none"
          style={{
            color: feedActive ? '#064e3b' : 'rgba(0,0,0,0.35)',
            fontWeight: feedActive ? 600 : 400,
          }}
        >
          Feed
        </span>
      </button>

      {/* Add */}
      <button
        onClick={onAddClick}
        className="w-[42px] h-[42px] flex items-center justify-center bg-[#064e3b]"
        style={{ borderRadius: '13px', boxShadow: '0 3px 8px rgba(6,78,59,0.30)' }}
        aria-label="Add"
      >
        <Plus className="w-5 h-5 text-white" strokeWidth={2.5} />
      </button>

      {/* Clips */}
      <button
        onClick={() => setActiveTab('clipboard')}
        className="flex flex-col items-center justify-center gap-[3px] px-4 py-2 rounded-full transition-all"
        style={{ background: clipsActive ? 'rgba(0,0,0,0.07)' : 'transparent' }}
        aria-label="Clips"
      >
        <Clipboard
          className="w-[18px] h-[18px]"
          style={{ color: clipsActive ? '#064e3b' : 'rgba(0,0,0,0.35)' }}
          strokeWidth={1.75}
        />
        <span
          className="text-[10px] leading-none"
          style={{
            color: clipsActive ? '#064e3b' : 'rgba(0,0,0,0.35)',
            fontWeight: clipsActive ? 600 : 400,
          }}
        >
          Clips
        </span>
      </button>
    </div>
  );
});

BottomTabBar.displayName = 'BottomTabBar';

BottomTabBar.propTypes = {
  activeTab: PropTypes.string.isRequired,
  setActiveTab: PropTypes.func.isRequired,
  onAddClick: PropTypes.func,
};

export default PhoneHeader;
